// Requiere: html5-qrcode, axios, jsqr

import React, { useState, useRef, useEffect } from 'react';

// ===== FUNCIONES DE SEGURIDAD PARA LOCALSTORAGE =====
// Prevenir errores cuando el navegador bloquea localStorage (Xiaomi/Redmi/Incognito)
function safeGetItem(key) {
  try {
    return localStorage.getItem(key);
  } catch (e) {
    console.warn(`[LocalStorage] No se pudo leer "${key}":`, e.message);
    return null;
  }
}

function safeSetItem(key, value) {
  try {
    localStorage.setItem(key, value);
  } catch (e) {
    console.warn(`[LocalStorage] No se pudo guardar "${key}":`, e.message);
  }
}

function safeRemoveItem(key) {
  try {
    localStorage.removeItem(key);
  } catch (e) {
    console.warn(`[LocalStorage] No se pudo eliminar "${key}":`, e.message);
  }
}

// Utilidad para generar UUID v4
function generateUUID() {
  // https://stackoverflow.com/a/2117523/2715716
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}
import { Html5Qrcode } from 'html5-qrcode';
import jsQR from 'jsqr';
import axios from 'axios';
import dayjs from './custom-months';
import './FichajeQR.css';
import FichajeGPS from './FichajeGPS';

// Los estilos para las animaciones de onboarding ahora están en FichajeQR.css

function QRScannerModal({ selectedCamera, onSwitchCamera, onImageUpload, onCancel }) {
  return (
    <div id="qr-overlay-modal" className="qr-modern-overlay">
      <div className="qr-modern-modal">
        <div className="qr-modern-reader-frame">
          <div id="qr-reader"></div>
        </div>

        {/iPad|iPhone|iPod/.test(navigator.userAgent) && (
          <div className="qr-modern-tip">
            <strong>Consejo para iPhone:</strong> si la cámara no funciona, añade la app a la pantalla de inicio.
          </div>
        )}

        <button type="button" className="qr-modern-secondary" onClick={onSwitchCamera}>
          Cambiar a cámara {selectedCamera === 'user' ? 'trasera' : 'frontal'}
        </button>

        <label className="qr-modern-upload-label" htmlFor="qr-modern-upload">
          ¿No funciona el escaneo? Sube una foto del QR
        </label>
        <input
          id="qr-modern-upload"
          className="qr-modern-upload"
          type="file"
          accept="image/*"
          onChange={onImageUpload}
        />

        <button type="button" className="qr-modern-cancel" onClick={onCancel}>
          Cancelar
        </button>
      </div>
    </div>
  );
}

export default function FichajeQR() {
  // Empresa del usuario (multiempresa)
  const [empresa, setEmpresa] = useState(() => safeGetItem('empresa') || '');
  // user_id persistente por dispositivo
  const [userId, setUserId] = useState(() => {
    let uid = safeGetItem('user_id');
    if (!uid) {
      uid = generateUUID();
      safeSetItem('user_id', uid);
    }
    return uid;
  });
  // Estados principales
  const [showLogin, setShowLogin] = useState(!safeGetItem('dni'));
  const [showWelcome, setShowWelcome] = useState(false);
  const [onboardingStep, setOnboardingStep] = useState(0); // 0: nada, 1: bienvenida, 2: url, 3: nombre, 4: dni, 5: departamento, 6: gracias
  const [welcomeBg, setWelcomeBg] = useState('#1976d2');
  const [logo, setLogo] = useState(null);
  // Usar SIEMPRE la URL fija del backend, ignorando localStorage y variables de entorno
  const [backendUrl, setBackendUrl] = useState('https://qradmin.acgestel.com');
  const [dni, setDni] = useState(() => safeGetItem('dni') || '');
  const [nombre, setNombre] = useState(() => safeGetItem('nombre') || '');
  const [departamento, setDepartamento] = useState(() => safeGetItem('departamento') || '');
  const [mensaje, setMensaje] = useState('');
  const [advertencia, setAdvertencia] = useState('');
  const [scanning, setScanning] = useState(false);
  const [logoError, setLogoError] = useState(false);
  const [tipo, setTipo] = useState(() => safeGetItem('tipo') || 'entrada');
  const [mes, setMes] = useState((new Date().getMonth() + 1).toString());
  const [anio, setAnio] = useState(new Date().getFullYear().toString());
  const [activeTab, setActiveTab] = useState('fichar');
  const [horario, setHorario] = useState([]); // para los datos de horario
  const [horarioBloqueado, setHorarioBloqueado] = useState(false);
  const [horarioBloqueadoMsg, setHorarioBloqueadoMsg] = useState('');
  const HORARIO_BLOQUEADO_FALLBACK = 'Descarga de mi horario bloqueada por asuntos administrativos. Si desea saber sus horas contacte con administracion o espere hasta final de mes. Gracias y perdone las molestias.';
  const [ficharTrigger, setFicharTrigger] = useState(0); // Trigger para sincronizar tipo después de fichar
  const [darkMode, setDarkMode] = useState(() => {
    const saved = safeGetItem('gps_dark_mode');
    return saved !== null ? saved === 'true' : true;
  });
  const html5QrCodeRef = useRef(null);
  const sessionRepairAttemptsRef = useRef(new Set());

  // --- EASTER EGG: 3 TOQUES PARA MOSTRAR BOTÓN SALIR ---
  const [tapCount, setTapCount] = useState(0);
  const [showLogoutButton, setShowLogoutButton] = useState(false);
  const tapTimeoutRef = useRef(null);

  // --- ESTADOS PARA CÁMARA ---
  const [availableCameras, setAvailableCameras] = useState([]);
  const [selectedCamera, setSelectedCamera] = useState(() => safeGetItem('selectedCamera') || 'environment');
  const [showCameraSelect, setShowCameraSelect] = useState(false);
  
  // --- PARTES DE TRABAJO (RECILEC) ---
  // CONFIGURACIÓN: Cambiar aquí para probar con tu departamento
  const DEPARTAMENTO_PARTES = 'GESTEL';
  const [parteCategoria, setParteCategoria] = useState('');
  const [parteTurno, setParteTurno] = useState('');
  const [parteOperarios, setParteOperarios] = useState([]);
  const [parteOperariosSeleccionados, setParteOperariosSeleccionados] = useState([]);
  const [parteItems, setParteItems] = useState({});
  const [parteServicioHoras, setParteServicioHoras] = useState({});
  const [parteDescripcion, setParteDescripcion] = useState('');
  const [parteGenerando, setParteGenerando] = useState(false);
  const [parteMensaje, setParteMensaje] = useState('');
  const [parteCargandoOps, setParteCargandoOps] = useState(false);

  // --- MODO DE FICHAJE RESUELTO POR EL BACKEND ---
  const [fichajeMode, setFichajeMode] = useState(() => safeGetItem('fichaje_mode') || 'unknown');
  const geoHabilitado = fichajeMode === 'gps';
  const [geoFichando, setGeoFichando] = useState(false);
  const [geoMensaje, setGeoMensaje] = useState('');
  const [authChecking, setAuthChecking] = useState(() => !!safeGetItem('dni'));

  // --- LOGIN DE USUARIO (DNI/CONTRASEÑA) ---
  const [loginDni, setLoginDni] = useState('');
  const [loginPassword, setLoginPassword] = useState('');
  const [loginError, setLoginError] = useState('');

  const syncFichajeMode = React.useCallback((payload) => {
    if (!payload || (typeof payload.geo_habilitado === 'undefined' && !payload.fichaje_mode)) {
      return null;
    }

    const nextMode = payload.fichaje_mode === 'gps' || payload.geo_habilitado === true ? 'gps' : 'qr';
    setFichajeMode(nextMode);
    safeSetItem('fichaje_mode', nextMode);
    return nextMode;
  }, []);

  const clearStoredUserSession = React.useCallback((message) => {
    safeRemoveItem('dni');
    safeRemoveItem('nombre');
    safeRemoveItem('departamento');
    safeRemoveItem('empresa');
    safeRemoveItem('tipo');
    safeRemoveItem('password');
    safeRemoveItem('fichaje_mode');
    setDni('');
    setNombre('');
    setDepartamento('');
    setEmpresa('');
    setTipo('entrada');
    setFichajeMode('unknown');
    setShowLogin(true);
    if (message) setMensaje(message);
  }, []);

  const repairUserSession = React.useCallback(async (reason) => {
    const storedDni = (dni || safeGetItem('dni') || '').trim();
    const storedPassword = safeGetItem('password');
    const currentDepartment = (departamento || safeGetItem('departamento') || '').trim();
    const attemptKey = `${reason}:${storedDni}:${currentDepartment}`;

    if (!storedDni || !storedPassword || !backendUrl) {
      return false;
    }

    if (sessionRepairAttemptsRef.current.has(attemptKey)) {
      return false;
    }

    sessionRepairAttemptsRef.current.add(attemptKey);

    try {
      console.warn(`[SESSION-REPAIR] Intentando reparar sesión: ${reason}`);
      const res = await axios.post(`${backendUrl}/api/login_usuario`, {
        dni: storedDni,
        password: storedPassword,
      }, { withCredentials: true });

      if (res.data && res.data.status === 'ok') {
        if (res.data.dni) {
          setDni(res.data.dni);
          safeSetItem('dni', res.data.dni);
        }
        if (res.data.nombre) {
          setNombre(res.data.nombre);
          safeSetItem('nombre', res.data.nombre);
        }
        if (res.data.departamento) {
          setDepartamento(res.data.departamento);
          safeSetItem('departamento', res.data.departamento);
        }
        if (res.data.empresa) {
          setEmpresa(res.data.empresa);
          safeSetItem('empresa', res.data.empresa);
        }
        syncFichajeMode(res.data);
        setShowLogin(false);
        setLoginError('');
        return true;
      }
    } catch (error) {
      console.warn('[SESSION-REPAIR] No se pudo reparar la sesión:', error.message);
    }

    return false;
  }, [backendUrl, departamento, dni, syncFichajeMode]);

  // Si no hay datos de usuario, mostrar login y refrescar nombre/departamento cada 1min si está en la pestaña
  useEffect(() => {
    let intervalId;
    // Función para obtener datos del usuario (adaptada a backend multiempresa)
    const fetchUserInfo = async (dniToFetch) => {
      try {
        const res = await axios.get(`${backendUrl}/api/usuario_info`, {
          params: { dni: dniToFetch },
          withCredentials: true
        });
        // Espera un objeto tipo { nombre, departamento, empresa } o null
        if (res.data && typeof res.data === 'object' && (res.data.nombre || res.data.departamento)) {
          if (res.data.dni) {
            setDni(res.data.dni);
            safeSetItem('dni', res.data.dni);
          }
          if (
            res.data.dni !== dni ||
            res.data.nombre !== nombre ||
            res.data.departamento !== departamento ||
            res.data.empresa !== empresa
          ) {
            if (res.data.nombre) {
              setNombre(res.data.nombre);
              safeSetItem('nombre', res.data.nombre);
            }
            if (res.data.departamento) {
              setDepartamento(res.data.departamento);
              safeSetItem('departamento', res.data.departamento);
            }
            // CRÍTICO: Sincronizar empresa desde backend si no está en localStorage
            if (res.data.empresa) {
              setEmpresa(res.data.empresa);
              safeSetItem('empresa', res.data.empresa);
              console.log('[SYNC] Empresa sincronizada desde backend:', res.data.empresa);
            }
          }
          syncFichajeMode(res.data);
          setShowLogin(false);
          setMensaje('');
        } else {
          const repaired = await repairUserSession('missing-user-info');
          if (!repaired) {
            clearStoredUserSession('Tu sesión se ha reiniciado. Inicia sesión de nuevo.');
          }
        }
      } catch (e) {
        if (e.response && e.response.status === 401) {
          const repaired = await repairUserSession('expired-session');
          if (!repaired) {
            clearStoredUserSession('Sesión expirada, por favor inicia sesión de nuevo.');
          }
        } else {
          const repaired = await repairUserSession('fetch-user-info-error');
          if (!repaired) {
            clearStoredUserSession('Tu sesión se ha reiniciado. Inicia sesión de nuevo.');
          }
        }
      } finally {
        setAuthChecking(false);
      }
    };
    // Autologin inicial
    const tryAutoLogin = async () => {
      const currentDni = dni || safeGetItem('dni');
      if (currentDni) {
        await fetchUserInfo(currentDni);
      } else {
        setAuthChecking(false);
        setShowLogin(true);
      }
    };
    tryAutoLogin();

    // Refrescar cada xmin si está en la pestaña de fichar
    if (dni && activeTab === 'fichar') {
      intervalId = setInterval(() => {
        fetchUserInfo(dni);
      }, 60000); // 60,000 ms = 1 min
    }
    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [dni, nombre, departamento, empresa, backendUrl, activeTab, clearStoredUserSession, repairUserSession, syncFichajeMode]);

  // Lógica de login
  const handleUserLogin = async (e) => {
    e.preventDefault();
    setLoginError('');
    try {
      const res = await axios.post(`${backendUrl}/api/login_usuario`, {
        dni: loginDni,
        password: loginPassword,
      }, { withCredentials: true }); // Asegura que las cookies se guarden
      if (res.data.status === 'ok') {
        // IMPORTANTE: Guardar en localStorage PRIMERO para que React lo vea
        safeSetItem('dni', res.data.dni);
        safeSetItem('nombre', res.data.nombre);
        safeSetItem('departamento', res.data.departamento);
        if (res.data.empresa) {
          safeSetItem('empresa', res.data.empresa);
        }
        syncFichajeMode(res.data);
        safeSetItem('password', loginPassword); // Guardar password para autologin (no recomendado en producción)
        
        // Actualizar estados
        setDni(res.data.dni);
        setNombre(res.data.nombre);
        setDepartamento(res.data.departamento);
        if (res.data.empresa) {
          setEmpresa(res.data.empresa);
        }
        
        // Cerrar login después de actualizar los estados
        setShowLogin(false);
        setLoginDni('');
        setLoginPassword('');
        setLoginError('');
      } else {
        setLoginError(res.data.mensaje || 'Error de login');
      }
    } catch (err) {
      setLoginError('Usuario o contraseña incorrectos');
    }
  };

  // Al cargar, si no hay datos, inicia onboarding
  // Eliminado: ya controlado por el efecto anterior

  // --- GEOLOC: Función para fichar por GPS ---
  const ficharConGPS = async () => {
    setGeoFichando(true);
    setGeoMensaje('Obteniendo ubicación GPS...');
    setMensaje('');
    setAdvertencia('');

    if (!navigator.geolocation) {
      setGeoMensaje('Tu navegador no soporta geolocalización');
      setGeoFichando(false);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;
        const precision = position.coords.accuracy;
        setGeoMensaje(`Ubicación obtenida (±${Math.round(precision)}m). Registrando fichaje...`);

        try {
          // Capturar info del dispositivo
          const device_user_agent = navigator.userAgent;
          let deviceInfo = {
            userAgent: device_user_agent,
            deviceMemory: navigator.deviceMemory || 'unknown',
            cores: navigator.hardwareConcurrency || 'unknown',
            maxTouchPoints: navigator.maxTouchPoints || 'unknown'
          };
          if (navigator.userAgentData) {
            try {
              let uaData = await navigator.userAgentData.getHighEntropyValues(['model', 'platform', 'platformVersion', 'brands']);
              deviceInfo.model = uaData.model || 'unknown';
              deviceInfo.platform = uaData.platform || 'unknown';
            } catch (e) {}
          }

          const resp = await axios.post(
            `${backendUrl}/api/fichar_geoloc`,
            {
              dni: dni,
              latitud: lat,
              longitud: lng,
              precision: precision,
              empresa: empresa || safeGetItem('empresa') || '',
              device_user_agent: device_user_agent,
              device_info: JSON.stringify(deviceInfo)
            },
            { withCredentials: true }
          );

          if (resp.data && resp.data.nombre) {
            setNombre(resp.data.nombre);
            safeSetItem('nombre', resp.data.nombre);
          }
          if (resp.data && resp.data.departamento) {
            setDepartamento(resp.data.departamento);
            safeSetItem('departamento', resp.data.departamento);
          }
          if (resp.data && resp.data.empresa) {
            setEmpresa(resp.data.empresa);
            safeSetItem('empresa', resp.data.empresa);
          }

          if (resp.data.status === 'ok') {
            const nuevoTipo = resp.data.tipo === 'entrada' ? 'salida' : 'entrada';
            setTipo(nuevoTipo);
            safeSetItem('tipo', nuevoTipo);

            const dentroZona = resp.data.dentro_zona;
            const distancia = resp.data.distancia;

            if (dentroZona) {
              setGeoMensaje(`✅ Fichaje registrado correctamente (${distancia}m del centro)`);
              setMensaje(`📍 ${resp.data.tipo.toUpperCase()} registrada por GPS correctamente`);
            } else {
              setGeoMensaje(`⚠️ Fichaje registrado FUERA DE ZONA (${distancia}m)`);
              setMensaje(`📍 ${resp.data.tipo.toUpperCase()} registrada por GPS`);
            }

            if (resp.data.advertencia) {
              setAdvertencia(resp.data.advertencia);
            }

            setFicharTrigger(prev => prev + 1);
          } else {
            setGeoMensaje('');
            setMensaje(resp.data.mensaje || 'Error al fichar por GPS');
          }
        } catch (err) {
          const errMsg = err.response?.data?.mensaje || err.message || 'Error de conexión';
          setGeoMensaje('');
          setMensaje('Error GPS: ' + errMsg);
        }
        setGeoFichando(false);
      },
      (error) => {
        let msg = 'Error obteniendo ubicación: ';
        switch (error.code) {
          case error.PERMISSION_DENIED:
            msg += 'Permiso de ubicación denegado. Activa el GPS en los ajustes del navegador.';
            break;
          case error.POSITION_UNAVAILABLE:
            msg += 'Ubicación no disponible. Comprueba que tienes GPS activo.';
            break;
          case error.TIMEOUT:
            msg += 'Tiempo de espera agotado. Inténtalo de nuevo.';
            break;
          default:
            msg += error.message;
        }
        setGeoMensaje(msg);
        setGeoFichando(false);
      },
      { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 }
    );
  };

  // Determinar tipo (entrada/salida) al cargar: si el último fichaje fue 'entrada', el siguiente debe ser 'salida', y viceversa
  // PERO si se auto-cerró (>11h59m sin salida), el siguiente debe ser 'entrada'
  useEffect(() => {
    async function checkTipo() {
      if (dni && backendUrl) {
        try {
          // Obtener todos los fichajes del usuario (sin filtrar por fecha)
          const res = await axios.get(`${backendUrl}/api/fichajes_usuario?dni=${dni}&fecha=all`, { withCredentials: true });
          if (res.data && res.data.fichajes && res.data.fichajes.length > 0) {
            // Si está auto-cerrado (>11h59m sin salida), el siguiente fichaje es 'entrada'
            if (res.data.auto_cerrado) {
              setTipo('entrada');
              safeSetItem('tipo', 'entrada');
            } else {
              // Tomar el último fichaje global
              const ultimo = res.data.fichajes[res.data.fichajes.length - 1];
              if (ultimo.tipo === 'entrada') {
                setTipo('salida');
                safeSetItem('tipo', 'salida');
              } else {
                setTipo('entrada');
                safeSetItem('tipo', 'entrada');
              }
            }
          } else {
            setTipo('entrada');
            safeSetItem('tipo', 'entrada');
          }
        } catch {
          setTipo('entrada');
          safeSetItem('tipo', 'entrada');
        }
      }
    }
    checkTipo();
  }, [dni, backendUrl, ficharTrigger]);

  useEffect(() => {
    // Cargar config de backend usando la URL completa
    axios.get(`${backendUrl}/api/config`).then(res => {
      setWelcomeBg(res.data.welcome_bg || '#1976d2');
      // Forzar logo global, ignorar el logo de empresa del backend
      setLogo('/icon-192.png');
    }).catch(() => {
      setWelcomeBg('#1976d2');
      setLogo('/icon-192.png');
    });
  }, [backendUrl]);

  // Guardar preferencias y cerrar config
  const savePrefs = () => {
    safeSetItem('backend_url', backendUrl);
    safeSetItem('dni', dni);
    safeSetItem('nombre', nombre);
    safeSetItem('departamento', departamento);
    if (empresa) safeSetItem('empresa', empresa);
    setShowConfig(false);
  };

  // Inicializa el QR solo cuando el div está en el DOM (para evitar errores de referencia)
  const startScan = () => {
    setMensaje('');
    setAdvertencia('');
    setScanning(true);
  };

  // Función para cambiar de cámara
  const switchCamera = async () => {
    if (html5QrCodeRef.current) {
      try {
        await html5QrCodeRef.current.stop();
      } catch (err) {
        console.log('Error deteniendo cámara:', err);
      }
    }
    
    // Alternar entre trasera y frontal
    const newCamera = selectedCamera === 'user' ? 'environment' : 'user';
    setSelectedCamera(newCamera);
    safeSetItem('selectedCamera', newCamera);
    setMensaje('Cambiando cámara...');
    
    // Reiniciar escaneo después de un pequeño delay
    setTimeout(() => {
      setMensaje('');
      startScan();
    }, 300);
  };

   useEffect(() => {
    if (scanning) {
      // Esperar a que el div esté en el DOM
      const interval = setInterval(() => {
        const qrDiv = document.getElementById('qr-reader');
        if (qrDiv) {
          clearInterval(interval);
          const startScanner = async () => {
            try {
              if (!html5QrCodeRef.current) {
                html5QrCodeRef.current = new Html5Qrcode('qr-reader');
              }
              
              // Detectar si es iOS y si está en modo aislamiento
              const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
              const isSafari = /Safari/.test(navigator.userAgent) && !/Chrome|Firefox|Edge/.test(navigator.userAgent);
              const isIsolationMode = window.webkit?.messageHandlers; // Indicador de modo aislamiento
              
              let cameraIdOrConstraint = undefined;
              
              try {
                const cameras = await Html5Qrcode.getCameras();
                if (Array.isArray(cameras) && cameras.length > 0) {
                  setAvailableCameras(cameras);
                  
                  // ESTRATEGIA MEJORADA PARA iOS
                  if (isIOS) {
                    // En iOS/Safari SIEMPRE usar facingMode SIN 'exact' (más compatible)
                    if (isSafari) {
                      // Safari iOS: usar constraints simples sin 'exact'
                      cameraIdOrConstraint = {
                        facingMode: selectedCamera === 'user' ? 'user' : 'environment'
                      };
                    } else {
                      // Otros navegadores en iOS: usar 'exact' para mejor control
                      if (selectedCamera === 'user') {
                        cameraIdOrConstraint = { facingMode: { exact: 'user' } };
                      } else {
                        cameraIdOrConstraint = { facingMode: { exact: 'environment' } };
                      }
                    }
                  } else {
                    // Android: usar IDs de cámara para mejor control
                    if (selectedCamera !== 'environment' && selectedCamera !== 'user') {
                      const selectedCam = cameras.find(c => c.id === selectedCamera);
                      if (selectedCam) {
                        cameraIdOrConstraint = selectedCam.id;
                      }
                    } else if (selectedCamera === 'user') {
                      const frontCam = cameras.find(c => /front|selfie|user|facing/i.test((c.label || '')));
                      if (frontCam) {
                        cameraIdOrConstraint = frontCam.id;
                      } else if (cameras.length > 1) {
                        cameraIdOrConstraint = cameras[1].id;
                      } else {
                        cameraIdOrConstraint = { facingMode: 'user' };
                      }
                    } else {
                      const backCam = cameras.find(c => /back|rear|environment|main|wide/i.test((c.label || ''))) || cameras[0];
                      cameraIdOrConstraint = backCam.id;
                    }
                  }
                }
              } catch (err) {
                console.error('Error obteniendo cámaras:', err);
                // Fallback seguro: siempre usar facingMode simple si falla
                cameraIdOrConstraint = {
                  facingMode: selectedCamera === 'user' ? 'user' : 'environment'
                };
              }

              const config = {
                fps: 24,
                qrbox: (viewW, viewH) => {
                  const s = Math.floor(Math.min(viewW, viewH) * 0.75);
                  return { width: s, height: s };
                },
                disableFlip: true,
                experimentalFeatures: { useBarCodeDetectorIfSupported: true },
              };

              const onScanSuccess = async (decodedText) => {
                try { await html5QrCodeRef.current.stop(); } catch {}
                setScanning(false);
                await fichar(decodedText);
              };
              
              const onScanError = (errorMessage) => { 
                // Log silencioso para debug
                console.debug('QR Scanner error:', errorMessage);
              };

              // Fallback final si cameraIdOrConstraint es undefined
              const finalConstraint = cameraIdOrConstraint || { facingMode: selectedCamera === 'user' ? 'user' : 'environment' };

              await html5QrCodeRef.current.start(
                finalConstraint,
                config,
                onScanSuccess,
                onScanError
              );
            } catch (err) {
              console.error('Error iniciando cámara:', err);
              
              // Mensajes específicos según el tipo de error (para iOS)
              let mensajeError = 'No se pudo iniciar la cámara. Revisa permisos o intenta cambiar de cámara.';
              
              if (err.message?.includes('NotAllowedError') || err.name === 'NotAllowedError') {
                mensajeError = '❌ Permiso denegado. En iPhone: Configura > Safari > Cámara y concede acceso.';
              } else if (err.message?.includes('NotFoundError') || err.name === 'NotFoundError') {
                mensajeError = '❌ No se encontró cámara. Intenta reiniciar Safari o agregar a pantalla de inicio.';
              } else if (err.message?.includes('NotSupportedError') || err.name === 'NotSupportedError') {
                mensajeError = '❌ Tu navegador no soporta acceso a cámara. Intenta Safari en lugar de Chrome.';
              } else if (err.message?.includes('Security') || err.message?.includes('https')) {
                mensajeError = '🔒 Debes estar en HTTPS. Cierra e intenta de nuevo.';
              }
              
              setMensaje(mensajeError);
              setScanning(false);
            }
          };
          startScanner();
        }
      }, 100);
      // Limpiar si se desmonta
      return () => clearInterval(interval);
    } else {
      // Si se cierra el modal, parar el QR solo si está activo
      if (html5QrCodeRef.current) {
        try {
          html5QrCodeRef.current.stop().catch(()=>{});
        } catch (e) {}
        html5QrCodeRef.current = null;
      }
    }
  }, [scanning, selectedCamera]);

  const fichar = async (qrdata) => {
    try {
      const now = new Date();
      // Forzar zona horaria de España peninsular (Europe/Madrid)
      const fecha = now.toLocaleDateString('es-ES', { timeZone: 'Europe/Madrid' });
      const hora = now.toLocaleTimeString('es-ES', { timeZone: 'Europe/Madrid' });
      // Validar campos antes de enviar
      if (!dni) {
        setMensaje('Por favor, rellena tu DNI antes de fichar.');
        setScanning(false);
        return;
      }
      // Capturar información del dispositivo
      const device_user_agent = navigator.userAgent;
      
      // Capturar información adicional del navegador/dispositivo
      let deviceInfo = {
        userAgent: device_user_agent,
        // DeviceMemory API (disponible en algunos navegadores Android)
        deviceMemory: navigator.deviceMemory || 'unknown',
        // Cores disponibles (WorkerNavigator.hardwareConcurrency)
        cores: navigator.hardwareConcurrency || 'unknown',
        // Max Touch Points (ayuda a diferenciar tablets de móviles)
        maxTouchPoints: navigator.maxTouchPoints || 'unknown'
      };
      
      // Si está disponible, intentar capturar datos de User-Agent Client Hints
      if (navigator.userAgentData) {
        try {
          let uaData = await navigator.userAgentData.getHighEntropyValues(['model', 'platform', 'platformVersion', 'brands']);
          deviceInfo.model = uaData.model || 'unknown';
          deviceInfo.platform = uaData.platform || 'unknown';
          deviceInfo.platformVersion = uaData.platformVersion || 'unknown';
          deviceInfo.brands = uaData.brands || [];
          console.log('[Device Detection] UserAgentData capturada:', {
            model: deviceInfo.model,
            platform: deviceInfo.platform,
            brands: deviceInfo.brands
          });
        } catch (e) {
          // Si falla, continuar con userAgent normal
          console.log('User-Agent Client Hints no disponible:', e);
        }
      }
      
      const resp = await axios.post(
        `${backendUrl}/api/fichar`,
        {
          user_id: userId,
          dni: dni,
          tipo: tipo,
          fecha: fecha,
          hora: hora,
          qrdata: qrdata,
          empresa: empresa || safeGetItem('empresa') || '',
          device_user_agent: device_user_agent,
          device_info: JSON.stringify(deviceInfo)
        },
        { withCredentials: true }
      );
      // Actualizar SIEMPRE los datos con los del backend
      if (resp.data && resp.data.nombre) {
        setNombre(resp.data.nombre);
        safeSetItem('nombre', resp.data.nombre);
      }
      if (resp.data && resp.data.departamento) {
        setDepartamento(resp.data.departamento);
        safeSetItem('departamento', resp.data.departamento);
      }
      if (resp.data && resp.data.empresa) {
        setEmpresa(resp.data.empresa);
        safeSetItem('empresa', resp.data.empresa);
      }
      if (resp.data && resp.data.dni) setDni(resp.data.dni);
      setMensaje(resp.data.mensaje);
      // Mostrar advertencia si existe
      if (resp.data && resp.data.advertencia) {
        setAdvertencia(resp.data.advertencia);
      } else {
        setAdvertencia('');
      }
      // Cambiar tipo solo si el fichaje fue correcto
      if (
        (resp.data && resp.data.mensaje && resp.data.mensaje.toLowerCase().includes('correctamente')) ||
        (resp.data && resp.data.success === true)
      ) {
        // El backend devuelve el tipo del fichaje que acaba de hacer
        // El PRÓXIMO tipo es el opuesto del que acaba de hacer
        const tipoQueAcabeHacer = resp.data.tipo;
        let proximoTipo = 'entrada'; // default
        
        if (tipoQueAcabeHacer === 'entrada') {
          proximoTipo = 'salida';
        } else if (tipoQueAcabeHacer === 'salida') {
          proximoTipo = 'entrada';
        }
        
        setTipo(proximoTipo);
        safeSetItem('tipo', proximoTipo);
        
        // Recargar horario DESPUÉS de actualizar el tipo, para mostrar el fichaje correcto
        await new Promise(resolve => setTimeout(resolve, 300));
        fetchHorario();
        
        // Trigger para sincronizar tipo desde backend (consultar último fichaje)
        setFicharTrigger(prev => prev + 1);
      }
      // Redirigir al login si el backend lo indica
      if (resp.data && resp.data.redirect === '/login') {
        setDni('');
        setNombre('');
        setDepartamento('');
        safeRemoveItem('nombre');
        safeRemoveItem('departamento');
        setTipo('entrada');
        setShowLogin(true);
        safeRemoveItem('dni');
      }
      setScanning(false);
    } catch (e) {
      if (e.response?.status === 409 && e.response?.data?.force_gps) {
        const forcedData = e.response.data;
        if (forcedData.dni) {
          setDni(forcedData.dni);
          safeSetItem('dni', forcedData.dni);
        }
        if (forcedData.nombre) {
          setNombre(forcedData.nombre);
          safeSetItem('nombre', forcedData.nombre);
        }
        if (forcedData.departamento) {
          setDepartamento(forcedData.departamento);
          safeSetItem('departamento', forcedData.departamento);
        }
        if (forcedData.empresa) {
          setEmpresa(forcedData.empresa);
          safeSetItem('empresa', forcedData.empresa);
        }
        syncFichajeMode(forcedData);
        setMensaje(forcedData.mensaje || 'Tu usuario ya usa fichaje GPS.');
        setAdvertencia('');
        setScanning(false);
        return;
      }

      // Si el backend devuelve redirect, forzar logout
      if (e.response && e.response.data && e.response.data.redirect === '/login') {
        setDni('');
        setNombre('');
        setDepartamento('');
        safeRemoveItem('nombre');
        safeRemoveItem('departamento');
        setTipo('entrada');
        setShowLogin(true);
        safeRemoveItem('dni');
        return;
      }
      let errorMsg = 'Error de conexión o de datos';
      if (e.response && e.response.data && e.response.data.mensaje) {
        errorMsg += ': ' + e.response.data.mensaje;
      } else if (e.response) {
        errorMsg += ` (status: ${e.response.status})`;
        if (e.response.data) {
          errorMsg += ` - ${JSON.stringify(e.response.data)}`;
        }
      } else if (e.request) {
        errorMsg += ': No se recibió respuesta del backend';
      } else if (e.message) {
        errorMsg += ': ' + e.message;
      }
      if (e.code) {
        errorMsg += ` (code: ${e.code})`;
      }
      setMensaje(errorMsg);
      console.error('Error al fichar:', e);
      setScanning(false);
    }
  };

  // Cargar horario del usuario al cambiar mes/año/dni
  const fetchHorario = async () => {
    if (dni && backendUrl && mes && anio) {
      try {
        const res = await axios.get(`${backendUrl}/api/fichajes/usuario_csv`, {
          params: { usuario: dni, year: anio, month: mes },
          withCredentials: true,
          responseType: 'text'
        });
        const text = typeof res.data === 'string' ? res.data : new TextDecoder('utf-8').decode(res.data);
        const rows = text
          .split('\n')
          .filter(row => row.trim() !== '')
          .map(row => row.split(',').map(cell => cell.replace(/^"|"$/g, '').trim()));
        const datos = rows.length > 1 ? rows.slice(1) : [];
        setHorario(datos);
        setHorarioBloqueado(false);
        setHorarioBloqueadoMsg('');
      } catch (e) {
        setHorario([]);
        if (e?.response?.status === 403) {
          const serverMsg = typeof e?.response?.data === 'string' ? e.response.data.trim() : '';
          setHorarioBloqueado(true);
          setHorarioBloqueadoMsg(serverMsg || HORARIO_BLOQUEADO_FALLBACK);
        } else {
          setHorarioBloqueado(false);
          setHorarioBloqueadoMsg('');
        }
      }
    } else {
      setHorario([]);
      setHorarioBloqueado(false);
      setHorarioBloqueadoMsg('');
    }
  };
  useEffect(() => { fetchHorario(); }, [dni, backendUrl, mes, anio]);

  // Descargar CSV del horario extensivo directamente desde el backend
  const descargarCSV = async () => {
    if (!dni || !anio || !mes) return;
    try {
      const urlParams = new URLSearchParams({
        year: anio,
        month: mes,
        dni: dni
      });
      const res = await fetch(`${backendUrl}/descargar_mi_horario_extensivo?${urlParams.toString()}`, {
        method: 'GET',
        credentials: 'include'
      });

      if (!res.ok) {
        const bodyText = await res.text().catch(() => '');
        const msg = bodyText && bodyText.trim()
          ? bodyText.trim()
          : 'No se pudo descargar el horario extensivo.';
        setMensaje(msg);
        if (res.status === 403) {
          setHorario([]);
          setHorarioBloqueado(true);
          setHorarioBloqueadoMsg(msg || HORARIO_BLOQUEADO_FALLBACK);
        }
        return;
      }

      const blob = await res.blob();
      const url = window.URL.createObjectURL(new Blob([blob], { type: 'text/csv' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `horario_extensivo_${dni}_${anio}_${mes}.csv`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      setHorarioBloqueado(false);
      setHorarioBloqueadoMsg('');
      setMensaje('Horario extensivo descargado correctamente.');
    } catch (e) {
      let msg = 'No se pudo descargar el horario extensivo.';
      if (e?.message) msg = e.message;
      setMensaje(msg);
    }
  };

  // ========== FUNCIONES PARTES DE TRABAJO ==========

  // Datos de tipos por categoría
  const TIPOS_CATEGORIAS = {
    frio: ['CHATARRA', 'RADIADORES', 'ACERO INOX', 'TRANSFORMADORES', 'ESPUMA', 'ALUMINIO',
           'MOTOR ELECTRICO', 'COMPRESOR', 'CABLES', 'CONDENSADORES', 'COBRE LIMPIO',
           'GAS', 'ACEITE', 'PLASTICO', 'BASURA'],
    cpus: ['CHAPAJO', 'M.PROCESADORES', 'CABLE MIX', 'PILAS', 'CD/DVD/DISQ', 'DISCOS DUROS',
           'FUENTE ALIMENT.', 'MEMORIA PLATA RAM', 'MEMORIA DORADA RAM', 'PLACAS LIGERAS', 'PLACAS PESADAS'],
    ofimatica: ['CHATARRA', 'PLASTICO', 'TONER', 'CABLE MIX', 'BASURA', 'PLACAS LIGERAS',
                'PLACAS PESADAS', 'VIDRIO', 'CLASIFICADOS', 'PULPO'],
    servicio: []
  };

  const obtenerTiposCategoria = (cat) => TIPOS_CATEGORIAS[cat] || [];

  // Cargar operarios del departamento
  const cargarOperariosPartes = async () => {
    if (parteOperarios.length > 0) return; // ya cargados
    setParteCargandoOps(true);
    try {
      const res = await axios.get(`${backendUrl}/api/recilec/operarios`, { withCredentials: true });
      if (res.data && res.data.operarios) {
        setParteOperarios(res.data.operarios);
      }
    } catch (e) {
      console.error('Error cargando operarios:', e);
      setParteMensaje('❌ Error al cargar operarios');
    } finally {
      setParteCargandoOps(false);
    }
  };

  // Limpiar formulario
  const limpiarFormularioParte = () => {
    setParteCategoria('');
    setParteTurno('');
    setParteOperariosSeleccionados([]);
    setParteItems({});
    setParteServicioHoras({});
    setParteDescripcion('');
    setParteMensaje('');
  };

  // Generar y descargar PDF
  const generarPartePDF = async () => {
    // Validaciones
    if (!parteTurno) { setParteMensaje('❌ Selecciona un turno (Mañana o Tarde)'); return; }
    if (!parteCategoria) { setParteMensaje('❌ Selecciona una categoría'); return; }
    if (parteOperariosSeleccionados.length === 0) { setParteMensaje('❌ Selecciona al menos un operario'); return; }

    // Preparar items (solo los que tienen cantidades reales)
    let items = [];
    if (parteCategoria !== 'servicio') {
      for (const [tipo, cantidades] of Object.entries(parteItems)) {
        const cantidadesValidas = cantidades.filter(c => c !== '' && parseFloat(c) > 0).map(c => parseFloat(c));
        if (cantidadesValidas.length > 0) {
          items.push({ tipo, cantidades: cantidadesValidas });
        }
      }
      if (items.length === 0) { setParteMensaje('❌ Añade al menos una cantidad'); return; }
    }

    // Preparar servicio_horas
    let servicio_horas = [];
    if (parteCategoria === 'servicio') {
      for (const [nombre, datos] of Object.entries(parteServicioHoras)) {
        const horas = datos?.horas || datos; // Compatible con ambas estructuras
        const observacion = datos?.observacion || '';
        if (horas && parseFloat(horas) > 0) {
          servicio_horas.push({ nombre, horas: parseFloat(horas), observacion });
        }
      }
      if (servicio_horas.length === 0) { setParteMensaje('❌ Asigna horas a al menos un empleado'); return; }
    }

    setParteGenerando(true);
    setParteMensaje('');

    try {
      const payload = {
        fecha: new Date().toISOString().split('T')[0],
        categoria: parteCategoria,
        turno: parteTurno,
        operarios: parteOperariosSeleccionados,
        items,
        servicio_horas,
        descripcion: parteDescripcion
      };

      const res = await axios.post(`${backendUrl}/api/recilec/generar_parte`, payload, {
        responseType: 'blob',
        withCredentials: true
      });

      // Descargar el archivo
      const contentType = res.headers['content-type'] || 'application/pdf';
      const ext = contentType.includes('pdf') ? 'pdf' : 'html';
      const url = window.URL.createObjectURL(new Blob([res.data], { type: contentType }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `parte_${parteCategoria}_${new Date().toISOString().split('T')[0]}_${parteTurno}.${ext}`);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);
      window.URL.revokeObjectURL(url);

      setParteMensaje('✅ PDF descargado correctamente');
    } catch (e) {
      console.error('Error generando parte:', e);
      if (e.response && e.response.data) {
        // Intentar leer error del blob
        try {
          const text = await e.response.data.text();
          const json = JSON.parse(text);
          setParteMensaje(`❌ ${json.msg || 'Error al generar el parte'}`);
        } catch {
          setParteMensaje('❌ Error al generar el parte');
        }
      } else {
        setParteMensaje('❌ Error de conexión al servidor');
      }
    } finally {
      setParteGenerando(false);
    }
  };

  // Hecho para ACGESTEL, pero se puede adaptar a cualquier empresa HECHO POR FMDB de ACGESTEL
  // Pantalla de configuración (solo permite editar nombre y backendUrl)
  // Eliminada: no debe existir configuración
  if (false) { return null; }

  if (authChecking) {
    return (
      <div className="welcome-screen">
        <div className="welcome-content" style={{width: '100%', boxSizing: 'border-box', padding: '20px', maxWidth: 400, margin: '0 auto', textAlign: 'center'}}>
          <img
            src="/icon-192.png"
            alt="Logo"
            className="welcome-logo bounce-in"
            onError={() => setLogoError(true)}
            style={{maxWidth: '90%'}}
          />
          <h1 className="welcome-title slide-in-up">Comprobando usuario...</h1>
        </div>
      </div>
    );
  }

  // Pantalla de login (solo si no hay datos)
  if (showLogin) {
    let logoSrc = '/icon-192.png';
    return (
      <div className="welcome-screen">
        <div className="welcome-content" style={{width: '100%', boxSizing: 'border-box', padding: '20px', maxWidth: 400, margin: '0 auto'}}>
          <img
            src={logoSrc}
            alt="Logo"
            className="welcome-logo bounce-in"
            onError={() => setLogoError(true)}
            style={{maxWidth: '90%'}}
          />
          <h1 className="welcome-title slide-in-up">Iniciar sesión</h1>
          <form onSubmit={handleUserLogin} style={{marginTop: 24}}>
            <input
              type="text"
              placeholder="DNI"
              value={loginDni}
              onChange={e => setLoginDni(e.target.value)}
              required
              style={{width: '100%', marginBottom: 12, padding: 8, borderRadius: 4, border: '1px solid #ccc'}}
            />
            <input
              type="password"
              placeholder="Contraseña"
              value={loginPassword}
              onChange={e => setLoginPassword(e.target.value)}
              required
              style={{width: '100%', marginBottom: 12, padding: 8, borderRadius: 4, border: '1px solid #ccc'}}
            />
            <button type="submit" className="welcome-btn bounce-in" style={{width: '100%'}}>Entrar</button>
          </form>
          {empresa && (
            <div style={{color: '#1976d2', marginTop: 10, fontWeight: 600}}>
            </div>
          )}
          {loginError && <div style={{color: '#e53e3e', marginTop: 12, fontWeight: 600}}>{loginError}</div>}
          <div style={{marginTop: 32, textAlign: 'center', color: '#fff'}}>
            <span>¿Nuevo usuario?</span>
            <button
              className="welcome-btn fade-in"
              style={{margin:15, background: '#1976d2', color: '#fff', fontWeight: 600, padding: '6px 18px', borderRadius: 4, border: 'none'}}
              onClick={() => { setShowLogin(false); setOnboardingStep(1); }}
            >
              Información
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Onboarding paso a paso
  if (onboardingStep > 0 && onboardingStep < 6) {
    // Indicadores de paso de onboarding
    const totalSteps = 5;
    const stepIndicators = [];
    for (let i = 1; i <= totalSteps; i++) {
      stepIndicators.push(
        <div 
          key={i} 
          className={`onboarding-step-dot ${onboardingStep === i ? 'active' : ''}`} 
        />
      );
    }

    // Usar logo local del frontend
    let logoSrc = '/icon-192.png';

    let content = null;
    if (onboardingStep === 1) {
      content = (
        <div className="slide-in-up" style={{width: '100%', textAlign: 'center'}}>
          <h1 className="welcome-title">¡Bienvenido!</h1>
          <p className="onboarding-subtitle">Ahora vamos a proceder a darte información del sistema de fichaje y como funciona.</p>
          <button 
            className="welcome-btn bounce-in" 
            onClick={() => setOnboardingStep(2)}
            style={{margin: '30px auto 0'}}
          >
            Continuar
          </button>
        </div>
      );
    } else if (onboardingStep === 2) {
      content = (
        <div className="slide-in-right" style={{width: '100%', textAlign: 'center'}}>
          <h2 className="onboarding-title">Fichaje</h2>
          <label className="onboarding-label">¿Como funciona?</label>
          <p className="onboarding-subtitle">El fichaje funciona de manera que tienes tienes que escanear el codigo qr en una Pantalla
          que lo contiene y desde tu dispositivo móvil. El código QR contiene la información necesaria para registrar tu entrada o salida y es unico para cada fichaje.</p>
          <button 
            className="welcome-btn fade-in" 
            onClick={() => setOnboardingStep(3)}
            style={{margin: '30px auto 0'}}
          >
            Continuar
          </button>
        </div>
      );
    } else if (onboardingStep === 3) {
      content = (
        <div className="slide-in-right" style={{width: '100%', textAlign: 'center'}}>
          <h2 className="onboarding-title">Horario</h2>
          <label className="onboarding-label">¿Como funciona?</label>
          <p className="onboarding-subtitle"> Esta aplicacion funciona guardando los datos cada vez que entras y sales, 
            guardando si era salida o una entrada(no hay limite de entradas y salidas pero deben estar justificadas)
            y guardando la fecha y hora. Mucha atencion pues siempre debe haber una salida despues de una entrada,
            si no, el sistema no te permitirá fichar una entrada y solo constara la entrada anterior.
            Puedes ver tu horario en la pestaña de "Horario" y descargarlo como CSV.</p>
          <button 
            className="welcome-btn fade-in" 
            onClick={() => setOnboardingStep(4)} 
            style={{margin: '30px auto 0'}}
          >
            Continuar
          </button>
        </div>
      );
    } else if (onboardingStep === 4) {
      content = (
        <div className="slide-in-right" style={{width: '100%', textAlign: 'center'}}>
          <h2 className="onboarding-title">Información extra</h2>
          <label className="onboarding-label">Como entrar:</label>
          <p className="onboarding-subtitle">"Introduce tu número de identificación (DNI). Este dato es imprescindible para registrar 
            tus fichajes y garantizar que solo tú puedas acceder a tu historial. El sistema protege tu privacidad y 
            solo tú y el administrador podrán ver tus datos."</p>
          <button 
            className="welcome-btn fade-in" 
            onClick={() => setOnboardingStep(5)} 
            style={{margin: '30px auto 0'}}
          >
            Continuar
          </button>
        </div>
      );
    } else if (onboardingStep === 5) {
      content = (
        <div className="slide-in-right" style={{width: '100%', textAlign: 'center'}}>
          <h2 className="onboarding-title">Departamento</h2>
          <label className="onboarding-label">¿Porque está departamento?</label>
          <p className="onboarding-subtitle">"Indica tu departamento. Esto ayuda a la empresa a organizar los registros 
            y a que el administrador pueda gestionar los horarios por áreas.</p>
          <button 
            className="welcome-btn bounce-in" 
            onClick={() => {
            setOnboardingStep(0);
            setShowLogin(true);
            }} 
            style={{margin: '30px auto 0'}}
          >
            Finalizar
          </button>
        </div>
      );
    }
    return (
      <div className="welcome-screen">
        <div className="welcome-content" style={{width: '100%', boxSizing: 'border-box', padding: '20px'}}>
          <img
            src={logoSrc}
            alt="Logo"
            className="welcome-logo bounce-in"
            onError={() => setLogoError(true)}
            style={{maxWidth: '90%'}}
          />
          <div className="onboarding-step-indicator" style={{width: '100%', justifyContent: 'center', marginBottom: '20px'}}>
            {stepIndicators}
          </div>
          <div className="onboarding-form-container" style={{width: '100%', maxWidth: '400px', boxSizing: 'border-box'}}>
            {content}
          </div>
        </div>
      </div>
    );
  }

  if (onboardingStep === 6) {
    return (
      <div className="welcome-screen">
        <div className="welcome-content" style={{width: '100%', boxSizing: 'border-box', padding: '20px'}}>
          <div className="bounce-in" style={{width: '100%', textAlign: 'center'}}>
            <h1 className="welcome-title">¡Gracias por su paciencia y diligencia!</h1>
            <p className="onboarding-subtitle">Ahora le pasamos a la aplicación principal.</p>
            <button 
              className="welcome-btn fade-in" 
              onClick={() => { 
                setOnboardingStep(0); 
                window.location.reload(); 
              }}
              style={{margin: '30px auto 0'}}
            >
              Entrar
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Pantalla de bienvenida
  if (showWelcome) {
    // Usar logo local del frontend
    let logoSrc = '/logo.png';
    return (
      <div className="welcome-screen">
        <div className="welcome-content">
          <img
            src={logoSrc}
            alt="Logo"
            className="welcome-logo bounce-in"
            onError={() => setLogoError(true)}
          />
          <h1 className="welcome-title slide-in-up">Sistema de Registro Laboral</h1>
          <button 
            className="welcome-btn fade-in" 
            onClick={() => setShowWelcome(false)}
          >
            Iniciar Sesión
          </button>
        </div>
      </div>
    );
  }


  // Si no hay datos de usuario, forzar login (protección extra)
// Este efecto puede causar renderizados extra y problemas de hooks si setShowLogin(true) cambia el flujo de renderizado.
// Mejor usarlo solo cuando el componente se monta, o eliminarlo si ya hay control de login en otros efectos.
// Si quiero forzar el login solo al montar, uso esto:
// useEffect(() => {
//   if (!dni || !nombre || !departamento) {
//     setShowLogin(true);
//   }
// }, []);

// Si ya tengo control de login en el resto del flujo, puedo eliminar este efecto.

  // Declarar la función antes de su uso en JSX/config
  const handleShowConfig = (show) => {
    if (show) {
      const url = safeGetItem('backend_url');
      if (url && url !== backendUrl) setBackendUrl(url);
    }
    setShowConfig(show);
  };

  // Función para desloguearse
  const handleLogout = () => {
    if (confirm('¿Estás seguro de que deseas cerrar sesión?')) {
      setDni('');
      setNombre('');
      setDepartamento('');
      setEmpresa('');
      setTipo('entrada');
      setFichajeMode('unknown');
      safeRemoveItem('dni');
      safeRemoveItem('nombre');
      safeRemoveItem('departamento');
      safeRemoveItem('empresa');
      safeRemoveItem('password');
      safeRemoveItem('fichaje_mode');
      safeRemoveItem('tipo');
      setShowLogin(true);
      setScanning(false);
    }
  };

  // Detectar 3 toques rápidos para mostrar botón salir (easter egg)
  const handleScreenTap = (e) => {
    // Ignorar si se hace click en botones o inputs
    const target = e.target;
    if (target.tagName === 'BUTTON' || target.tagName === 'INPUT' || target.tagName === 'SELECT' || target.closest('button') || target.closest('input') || target.closest('select')) {
      return;
    }

    // Incrementar contador
    setTapCount(prev => {
      const newCount = prev + 1;

      // Limpiar timeout anterior
      if (tapTimeoutRef.current) {
        clearTimeout(tapTimeoutRef.current);
      }

      // Si llegó a 3 toques, mostrar botón
      if (newCount === 3) {
        setShowLogoutButton(true);
        // Ocultar automáticamente después de 15 segundos
        tapTimeoutRef.current = setTimeout(() => {
          setShowLogoutButton(false);
          setTapCount(0);
        }, 15000);
        return 0; // Resetear contador
      }

      // Resetear contador después de 1.8 segundos si no se completan los 3 toques
      tapTimeoutRef.current = setTimeout(() => {
        setTapCount(0);
      }, 1800);

      return newCount;
    });
  };

  const closeQrScanner = async () => {
    if (html5QrCodeRef.current) {
      try {
        await html5QrCodeRef.current.stop();
      } catch (e) {
        // El lector puede haberse detenido ya tras detectar el código.
      }
    }
    setScanning(false);
  };

  const handleQrImageUpload = (e) => {
    const input = e.target;
    const file = input.files && input.files[0];
    if (!file) {
      setMensaje('No se seleccionó ningún archivo.');
      return;
    }

    setMensaje('Procesando imagen...');
    const imageUrl = URL.createObjectURL(file);
    const img = new Image();

    img.onload = async () => {
      try {
        if (html5QrCodeRef.current) {
          try {
            await html5QrCodeRef.current.stop();
          } catch (stopError) {
            console.warn('El lector QR ya estaba detenido:', stopError);
          }
        }

        let targetWidth = img.width;
        let targetHeight = img.height;
        const maxSize = 1500;
        if (img.width > maxSize || img.height > maxSize) {
          const scale = maxSize / Math.max(img.width, img.height);
          targetWidth = Math.floor(img.width * scale);
          targetHeight = Math.floor(img.height * scale);
        }

        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = targetWidth;
        canvas.height = targetHeight;
        ctx.drawImage(img, 0, 0, targetWidth, targetHeight);
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const code = jsQR(imageData.data, imageData.width, imageData.height, {
          inversionAttempts: 'attemptBoth',
        });

        setScanning(false);
        if (code?.data) {
          await fichar(code.data);
        } else {
          setMensaje('No se detectó ningún código QR. Usa una foto completa, enfocada y bien iluminada.');
        }
      } catch (err) {
        setScanning(false);
        setMensaje('Error al procesar la imagen: ' + (err?.message || 'Error desconocido'));
      } finally {
        URL.revokeObjectURL(imageUrl);
        input.value = '';
      }
    };

    img.onerror = () => {
      setScanning(false);
      setMensaje('Error al cargar la imagen. Intenta con otra foto.');
      URL.revokeObjectURL(imageUrl);
      input.value = '';
    };

    img.src = imageUrl;
  };

  // ===== GPS MODE: Render modern dashboard for geo-enabled departments =====
  if (fichajeMode === 'gps' || fichajeMode === 'qr') {
    return (
      <div className={`gps-dashboard ${darkMode ? 'dark' : 'light'}`} onClick={handleScreenTap}>
        {/* Top Tabs */}
        <div className="gps-tabs">
          <button className={`gps-tab-btn ${activeTab === 'fichar' ? 'active' : ''}`}
                  onClick={() => setActiveTab('fichar')}>{geoHabilitado ? '📍' : '▣'} Fichar</button>
          <button className={`gps-tab-btn ${activeTab === 'horario' ? 'active' : ''}`}
                  onClick={() => setActiveTab('horario')}>📋 Horario</button>
          <button className={`gps-tab-btn ${activeTab === 'usuario' ? 'active' : ''}`}
                  onClick={() => setActiveTab('usuario')}>👤 Usuario</button>
          {departamento.toUpperCase() === DEPARTAMENTO_PARTES && (
            <button className={`gps-tab-btn ${activeTab === 'partes' ? 'active' : ''}`}
                    onClick={() => { setActiveTab('partes'); cargarOperariosPartes(); }}>📋 Partes</button>
          )}
        </div>

        {activeTab === 'fichar' && (
          <FichajeGPS
            dni={dni}
            nombre={nombre}
            departamento={departamento}
            empresa={empresa}
            backendUrl={backendUrl}
            tipo={tipo}
            setTipo={setTipo}
            setNombre={setNombre}
            setDepartamento={setDepartamento}
            setEmpresa={setEmpresa}
            setMensaje={setMensaje}
            setAdvertencia={setAdvertencia}
            setFicharTrigger={setFicharTrigger}
            ficharTrigger={ficharTrigger}
            onInvalidUserSession={clearStoredUserSession}
            darkMode={darkMode}
            setDarkMode={setDarkMode}
            fichajeMode={fichajeMode}
            onQrScan={startScan}
            qrScanning={scanning}
            qrMensaje={mensaje}
            qrAdvertencia={advertencia}
          />
        )}

        {!geoHabilitado && scanning && (
          <QRScannerModal
            selectedCamera={selectedCamera}
            onSwitchCamera={switchCamera}
            onImageUpload={handleQrImageUpload}
            onCancel={closeQrScanner}
          />
        )}

        {activeTab === 'horario' && (
          <div className="gps-horario-section">
            <div className="gps-horario-card">
              <h3>📋 Mi horario</h3>
              <div className="gps-horario-row">
                <div className="gps-horario-field">
                  <label>Mes</label>
                  <select value={mes} onChange={e => setMes(e.target.value)}>
                    {[...Array(12)].map((_, i) => (
                      <option key={i+1} value={i+1}>{dayjs().month(i).format('MMMM')}</option>
                    ))}
                  </select>
                </div>
                <div className="gps-horario-field">
                  <label>Año</label>
                  <input type="number" value={anio} min="2000" max="2100" onChange={e => setAnio(e.target.value)} />
                </div>
              </div>
              {horarioBloqueado ? (
                <div className="horario-blocked-inline">
                  {horarioBloqueadoMsg || HORARIO_BLOQUEADO_FALLBACK}
                </div>
              ) : (
                <button onClick={descargarCSV} className="gps-horario-btn">
                  📥 Descargar Horario
                </button>
              )}
            </div>
          </div>
        )}

        {activeTab === 'usuario' && (
          <div className="gps-usuario-section">
            <div className="gps-usuario-card">
              <div className="gps-usuario-avatar-lg">
                {nombre ? (nombre.trim().split(/\s+/).length >= 2
                  ? (nombre.trim().split(/\s+/)[0][0] + nombre.trim().split(/\s+/)[1][0]).toUpperCase()
                  : nombre.substring(0, 2).toUpperCase()) : '??'}
              </div>
              <div className="gps-usuario-info">
                <div className="gps-usuario-field">
                  <span className="gps-usuario-label">DNI</span>
                  <span className="gps-usuario-value">{dni}</span>
                </div>
                <div className="gps-usuario-field">
                  <span className="gps-usuario-label">Nombre</span>
                  <span className="gps-usuario-value">{nombre}</span>
                </div>
                <div className="gps-usuario-field">
                  <span className="gps-usuario-label">Departamento</span>
                  <span className="gps-usuario-value">{departamento}</span>
                </div>
                <div className="gps-usuario-field">
                  <span className="gps-usuario-label">Empresa</span>
                  <span className="gps-usuario-value">{empresa}</span>
                </div>
              </div>
            </div>
            {showLogoutButton && (
              <button onClick={handleLogout} className="gps-logout-btn">
                🚪 Cerrar sesión
              </button>
            )}
          </div>
        )}

        {activeTab === 'partes' && departamento.toUpperCase() === DEPARTAMENTO_PARTES && (
          <div style={{padding: '16px'}}>
            <div className="partes-container" style={{background: 'rgba(30,41,59,0.8)', border: '1px solid #334155', borderRadius: 16, padding: 18, color: '#e2e8f0'}}>
              <h3 style={{textAlign:'center', marginBottom:16, color:'#a5b4fc', fontSize:'1.3rem'}}>📋 Nuevo Parte de Trabajo</h3>

              <div className="parte-seccion">
                <label className="parte-label" style={{color: '#94a3b8'}}>📅 Fecha</label>
                <input type="date" value={new Date().toISOString().split('T')[0]} readOnly
                  className="parte-input" style={{background:'#0f172a', color: '#e2e8f0', border: '1px solid #475569', cursor:'not-allowed'}} />
              </div>

              <div className="parte-seccion">
                <label className="parte-label" style={{color: '#94a3b8'}}>⏰ Turno</label>
                <div className="parte-radio-group">
                  <button type="button"
                    className={`parte-radio-btn ${parteTurno === 'M' ? 'selected' : ''}`}
                    onClick={() => setParteTurno('M')}>☀️ Mañana</button>
                  <button type="button"
                    className={`parte-radio-btn ${parteTurno === 'T' ? 'selected' : ''}`}
                    onClick={() => setParteTurno('T')}>🌙 Tarde</button>
                </div>
              </div>

              <div className="parte-seccion">
                <label className="parte-label" style={{color: '#94a3b8'}}>📦 Categoría</label>
                <div className="parte-categoria-grid">
                  {[{key:'frio', icon:'❄️', label:'Frío'}, {key:'cpus', icon:'💻', label:"CPU's"}, {key:'ofimatica', icon:'🖨️', label:'Ofimática'}, {key:'servicio', icon:'🤝', label:'Servicio Cliente'}].map(cat => (
                    <button key={cat.key} type="button"
                      className={`parte-cat-btn ${parteCategoria === cat.key ? 'selected' : ''}`}
                      onClick={() => { setParteCategoria(cat.key); setParteItems({}); setParteServicioHoras({}); }}>
                      <span style={{fontSize:'1.8rem'}}>{cat.icon}</span>
                      <span>{cat.label}</span>
                    </button>
                  ))}
                </div>
              </div>

              <div className="parte-seccion">
                <label className="parte-label" style={{color: '#94a3b8'}}>👷 Operarios</label>
                {parteCargandoOps ? (
                  <div style={{textAlign:'center', padding:10, color:'#64748b'}}>Cargando operarios...</div>
                ) : (
                  <div className="parte-operarios-list">
                    {parteOperarios.map(op => (
                      <button key={op.dni} type="button"
                        className={`parte-operario-btn ${parteOperariosSeleccionados.includes(op.nombre) ? 'selected' : ''}`}
                        onClick={() => {
                          setParteOperariosSeleccionados(prev =>
                            prev.includes(op.nombre) ? prev.filter(n => n !== op.nombre) : [...prev, op.nombre]
                          );
                        }}>
                        {parteOperariosSeleccionados.includes(op.nombre) ? '✅' : '⬜'} {op.nombre}
                      </button>
                    ))}
                    {parteOperarios.length === 0 && <div style={{color:'#64748b', padding:10}}>No hay operarios activos en {DEPARTAMENTO_PARTES}</div>}
                  </div>
                )}
              </div>

              {parteCategoria && parteCategoria !== 'servicio' && (
                <div className="parte-seccion">
                  <label className="parte-label" style={{color: '#94a3b8'}}>⚖️ Cantidades (kg)</label>
                  <div className="parte-tipos-list">
                    {obtenerTiposCategoria(parteCategoria).map(tipo_cat => (
                      <div key={tipo_cat} className="parte-tipo-row">
                        <div className="parte-tipo-nombre">{tipo_cat}</div>
                        <div className="parte-tipo-cantidades">
                          {(parteItems[tipo_cat] || ['']).map((cant, idx) => (
                            <div key={idx} className="parte-cant-row">
                              <input type="number" inputMode="decimal" placeholder="kg"
                                className="parte-kg-input"
                                value={cant}
                                onChange={e => {
                                  const val = e.target.value;
                                  setParteItems(prev => {
                                    const arr = [...(prev[tipo_cat] || [''])];
                                    arr[idx] = val;
                                    return {...prev, [tipo_cat]: arr};
                                  });
                                }} />
                              {idx === (parteItems[tipo_cat] || ['']).length - 1 && (
                                <button type="button" className="parte-add-cant-btn"
                                  onClick={() => setParteItems(prev => ({...prev, [tipo_cat]: [...(prev[tipo_cat] || ['']), '']}))}
                                  title="Añadir cantidad">+</button>
                              )}
                              {(parteItems[tipo_cat] || ['']).length > 1 && (
                                <button type="button" className="parte-remove-cant-btn"
                                  onClick={() => setParteItems(prev => {
                                    const arr = [...(prev[tipo_cat] || [''])];
                                    arr.splice(idx, 1);
                                    return {...prev, [tipo_cat]: arr};
                                  })}
                                  title="Quitar cantidad">✕</button>
                              )}
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {parteCategoria === 'servicio' && (
                <div className="parte-seccion">
                  <label className="parte-label" style={{color: '#94a3b8'}}>🕐 Empleados - Observación y Horas</label>
                  <div className="parte-tipos-list">
                    {parteOperariosSeleccionados.length === 0 && (
                      <div style={{color:'#64748b', padding:10}}>Selecciona operarios primero</div>
                    )}
                    {parteOperariosSeleccionados.map(nombre_op => (
                      <div key={nombre_op} className="parte-tipo-row" style={{display:'grid', gap:8}}>
                        <div style={{fontWeight:'bold', fontSize:'0.95rem'}}>{nombre_op}</div>
                        <div style={{marginLeft:0}}>
                          <input type="text" placeholder="Observación"
                            style={{width:'100%', padding:'8px', border:'1px solid #475569', borderRadius:'4px', fontSize:'0.95rem', marginBottom:6, background:'#0f172a', color:'#e2e8f0'}}
                            value={parteServicioHoras[nombre_op]?.observacion || ''}
                            onChange={e => setParteServicioHoras(prev => ({...prev, [nombre_op]: {...(prev[nombre_op] || {}), observacion: e.target.value}}))} />
                        </div>
                        <div style={{display:'flex', gap:8, alignItems:'center'}}>
                          <input type="number" inputMode="decimal" placeholder="horas"
                            className="parte-kg-input" style={{maxWidth:120, flex:1}}
                            value={parteServicioHoras[nombre_op]?.horas || ''}
                            onChange={e => setParteServicioHoras(prev => ({...prev, [nombre_op]: {...(prev[nombre_op] || {}), horas: e.target.value}}))} />
                          <span style={{color:'#94a3b8', fontSize:'0.9rem', whiteSpace:'nowrap'}}>horas</span>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {parteCategoria !== 'servicio' && (
                <div className="parte-seccion">
                  <label className="parte-label" style={{color: '#94a3b8'}}>📝 Descripción (opcional)</label>
                  <textarea className="parte-textarea" rows="3" placeholder="Escribe una observación..."
                    style={{background:'#0f172a', color:'#e2e8f0', border:'1px solid #475569'}}
                    value={parteDescripcion} onChange={e => setParteDescripcion(e.target.value)} />
                </div>
              )}

              {parteCategoria === 'servicio' && (
                <div className="parte-seccion">
                  <label className="parte-label" style={{color: '#94a3b8'}}>👤 Responsable</label>
                  <input type="text" className="parte-input" placeholder="Nombre del responsable"
                    style={{background:'#0f172a', color:'#e2e8f0', border:'1px solid #475569'}}
                    value={parteDescripcion} onChange={e => setParteDescripcion(e.target.value)} />
                </div>
              )}

              {parteMensaje && (
                <div style={{
                  padding: '12px 16px', borderRadius: 8, marginBottom: 12, fontWeight: 600, textAlign: 'center',
                  background: parteMensaje.includes('✅') ? 'rgba(34,197,94,0.15)' : 'rgba(239,68,68,0.15)',
                  color: parteMensaje.includes('✅') ? '#4ade80' : '#f87171',
                  border: `1px solid ${parteMensaje.includes('✅') ? 'rgba(34,197,94,0.3)' : 'rgba(239,68,68,0.3)'}`
                }}>{parteMensaje}</div>
              )}

              <div className="parte-botones">
                <button type="button" className="parte-btn-principal"
                  disabled={parteGenerando} onClick={generarPartePDF}>
                  {parteGenerando ? '⏳ Generando...' : '📥 Generar y Descargar PDF'}
                </button>
                <button type="button" className="parte-btn-secundario"
                  onClick={limpiarFormularioParte}>🗑️ Limpiar</button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  // ===== STANDARD MODE: Original QR-based interface =====
  return (
    <React.Fragment>
      {/* Estilos para asegurar que el canvas/video del QR no sobresalga del modal */}
      <style>{`
        #qr-reader, #qr-reader > div, #qr-reader video, #qr-reader canvas {
          max-width: 100% !important;
          max-height: 100% !important;
          width: 100% !important;
          height: 100% !important;
          border-radius: 16px !important;
          overflow: hidden !important;
          object-fit: cover !important;
        }
        #qr-overlay-modal {
          overscroll-behavior: none;
        }
      `}</style>
      <div className="fichaje-container" style={{width: '100%', boxSizing: 'border-box'}} onClick={handleScreenTap}>
      <h2 className="header-title">Sistema de Registro Laboral</h2>
      <div className="nav-buttons-container">
        <button 
          onClick={() => setActiveTab('fichar')} 
          className={`nav-button ${activeTab === 'fichar' ? 'active' : ''}`}
        >
          Fichar
        </button>
        <button 
          onClick={() => setActiveTab('horario')} 
          className={`nav-button ${activeTab === 'horario' ? 'active' : ''}`}
        >
          Horario
        </button>
        {departamento.toUpperCase() === DEPARTAMENTO_PARTES && (
          <button 
            onClick={() => { setActiveTab('partes'); cargarOperariosPartes(); }} 
            className={`nav-button ${activeTab === 'partes' ? 'active' : ''}`}
            style={{background: activeTab === 'partes' ? '#059669' : undefined}}
          >
            📋 Partes
          </button>
        )}
        {showLogoutButton && (
          <button 
            onClick={handleLogout}
            className="nav-button logout-button"
            title="Cerrar sesión"
            style={{
              marginLeft: 'auto',
              background: '#ef4444',
              color: '#fff',
              fontSize: '12px',
              animation: 'pulse 0.3s ease-in-out'
            }}
            onMouseEnter={(e) => e.target.style.background = '#dc2626'}
            onMouseLeave={(e) => e.target.style.background = '#ef4444'}
          >
            🚪 Salir
          </button>
        )}

      </div>
      <div className="user-info-display">
        <div className="user-info-item">
          <div className="user-info-label">DNI</div>
          <div className="user-info-value" style={{color:'#888'}}>{dni}</div>
        </div>
        <div className="user-info-item">
          <div className="user-info-label">Nombre</div>
          <div className="user-info-value" style={{color:'#888'}}>{nombre}</div>
        </div>
        <div className="user-info-item">
          <div className="user-info-label">Departamento</div>
          <div className="user-info-value" style={{color:'#888'}}>{departamento}</div>
        </div>
        <div className="user-info-item">
          <div className="user-info-label">Empresa</div>
          <div className="user-info-value" style={{color:'#888'}}>{empresa}</div>
        </div>
      </div>
      {activeTab === 'fichar' && (
        <>
          <div className="scan-container">
            <div className="form-row">
              <div className="form-field">
                <div className="user-info-label">Tipo de registro:</div>
                <div className={`tipo-badge tipo-${tipo}`}>{tipo}</div>
              </div>
              <div className="form-field scan-button">
                <button 
                  onClick={() => { startScan(); }} 
                  disabled={scanning}
                  className="action-button"
                >
                  {scanning ? 'Escaneando...' : 'Escanear QR y Registrar'}
                </button>
              </div>
            </div>
            {/* --- BOTÓN FICHAJE POR GPS (solo si departamento tiene geoloc habilitado) --- */}
            {geoHabilitado && (
              <div style={{marginTop: 12, textAlign: 'center'}}>
                <div style={{
                  background: '#f0fdf4',
                  border: '2px solid #22c55e',
                  borderRadius: 12,
                  padding: '14px 16px',
                  marginBottom: 8
                }}>
                  <p style={{fontSize: 13, color: '#166534', marginBottom: 10, fontWeight: 500}}>
                    📍 Tu departamento permite fichaje por GPS
                  </p>
                  <button
                    onClick={ficharConGPS}
                    disabled={geoFichando}
                    style={{
                      width: '100%',
                      padding: '14px 20px',
                      background: geoFichando ? '#86efac' : 'linear-gradient(135deg, #22c55e, #16a34a)',
                      color: '#fff',
                      border: 'none',
                      borderRadius: 10,
                      fontWeight: 700,
                      fontSize: 16,
                      cursor: geoFichando ? 'wait' : 'pointer',
                      boxShadow: '0 4px 12px rgba(34,197,94,0.3)',
                      transition: 'all 0.2s'
                    }}
                  >
                    {geoFichando ? '📡 Obteniendo ubicación...' : '📍 Fichar con GPS'}
                  </button>
                  {geoMensaje && (
                    <p style={{
                      marginTop: 10,
                      fontSize: 13,
                      fontWeight: 600,
                      color: geoMensaje.includes('✅') ? '#166534' : geoMensaje.includes('⚠️') ? '#d97706' : '#dc2626',
                      padding: '8px',
                      borderRadius: 6,
                      background: geoMensaje.includes('✅') ? '#dcfce7' : geoMensaje.includes('⚠️') ? '#fef3c7' : '#fee2e2'
                    }}>
                      {geoMensaje}
                    </p>
                  )}
                </div>
              </div>
            )}
          </div>
          {scanning && (
            <div
              id="qr-overlay-modal"
              style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                background: 'rgba(0,0,0,0.85)',
                zIndex: 99999,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.2s',
                overscrollBehavior: 'none',
              }}
            >
              <div
                style={{
                  background: '#fff',
                  borderRadius: 16,
                  padding: 18,
                  boxShadow: '0 4px 32px rgba(0,0,0,0.18)',
                  maxWidth: 420,
                  width: '95vw',
                  minHeight: 340,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'relative',
                }}
              >
                <div style={{ width: 340, maxWidth: '90vw', minHeight: 320, overflow: 'hidden', borderRadius: 16 }}>
                  <div id="qr-reader" style={{ width: '100%', minHeight: 320, borderRadius: 16, overflow: 'hidden', background: '#000' }}></div>
                </div>
                <div style={{ marginTop: 18, width: '100%', textAlign: 'center' }}>
                  {/* Mensaje de ayuda para iOS */}
                  {/iPad|iPhone|iPod/.test(navigator.userAgent) && (
                    <div style={{
                      background: '#FFF3E0',
                      border: '1px solid #FFB74D',
                      borderRadius: 8,
                      padding: 12,
                      marginBottom: 12,
                      fontSize: 13,
                      color: '#E65100',
                      fontWeight: 500
                    }}>
                      💡 <strong>Consejo para iPhone:</strong> Si la cámara no funciona, intenta agregar esta app a tu pantalla de inicio (Compartir → Agregar a pantalla de inicio)
                    </div>
                  )}
				<button
                    onClick={switchCamera}
                    style={{
                      display: 'block',
                      width: '100%',
                      padding: '10px 16px',
                      marginBottom: 12,
                      background: '#2196f3',
                      color: '#fff',
                      border: 'none',
                      borderRadius: 8,
                      fontWeight: 600,
                      cursor: 'pointer',
                      fontSize: 14,
                      transition: 'all 0.2s'
                    }}
                    onMouseEnter={(e) => e.target.style.background = '#1976d2'}
                    onMouseLeave={(e) => e.target.style.background = '#2196f3'}
                  >
                    Cambiar a cámara {selectedCamera === 'user' ? 'trasera' : 'frontal'}
                  </button>
                  <label htmlFor="qr-upload" style={{ display: 'block', marginBottom: 8, fontWeight: 600 }}>¿No funciona el escaneo? Sube una foto del QR:</label>
                  <input
                    id="qr-upload"
                    type="file"
                    accept="image/*"
                    style={{ marginBottom: 8 }}
                    onChange={(e) => {
                      const file = e.target.files && e.target.files[0];
                      console.log('Archivo recibido para escaneo:', file);
                      if (!file) {
                        setMensaje('No se seleccionó ningún archivo.');
                        return;
                      }
                      
                      setMensaje('Procesando imagen...');
                      
                      // Detener escaneo de cámara si está activo
                      if (scanning && html5QrCodeRef.current) {
                        html5QrCodeRef.current.stop().then(() => {
                          setScanning(false);
                        }).catch((err) => {
                          console.warn('Error al detener cámara:', err);
                          setScanning(false);
                        });
                      }
                      
                      // Leer archivo como imagen
                      const imageUrl = URL.createObjectURL(file);
                      const img = new Image();
                      
                      img.onload = () => {
                        try {
                          console.log('Imagen cargada:', img.width, 'x', img.height);
                          
                          // Redimensionar si es muy grande (>1500px) para mejorar rendimiento
                          let targetWidth = img.width;
                          let targetHeight = img.height;
                          const maxSize = 1500;
                          
                          if (img.width > maxSize || img.height > maxSize) {
                            const scale = maxSize / Math.max(img.width, img.height);
                            targetWidth = Math.floor(img.width * scale);
                            targetHeight = Math.floor(img.height * scale);
                            console.log('Redimensionando a:', targetWidth, 'x', targetHeight);
                          }
                          
                          // Crear canvas para procesar la imagen
                          const canvas = document.createElement('canvas');
                          const ctx = canvas.getContext('2d');
                          canvas.width = targetWidth;
                          canvas.height = targetHeight;
                          ctx.drawImage(img, 0, 0, targetWidth, targetHeight);
                          
                          // Obtener datos de imagen
                          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                          
                          console.log('Intentando detectar QR con inversionAttempts: attemptBoth...');
                          console.log('Datos de imagen:', {
                            width: imageData.width,
                            height: imageData.height,
                            dataLength: imageData.data.length
                          });
                          
                          // Escanear con jsQR - CAMBIO CLAVE: attemptBoth intenta normal e invertido
                          let code = jsQR(imageData.data, imageData.width, imageData.height, {
                            inversionAttempts: 'attemptBoth',
                          });
                          
                          console.log(' Resultado completo de jsQR:', code);
                          
                          if (code) {
                            console.log(' Detalles del objeto detectado:', {
                              data: code.data,
                              location: code.location,
                              binaryData: code.binaryData,
                              chunks: code.chunks,
                              version: code.version
                            });
                          }
                          
                          // Limpiar URL temporal
                          URL.revokeObjectURL(imageUrl);
                          
                          if (code && code.data) {
                            console.log('QR detectado con datos:', code.data);
                            fichar(code.data);
                          } else if (code) {
                            console.log(' Se detectó algo pero sin datos válidos');
                            setMensaje('Se detectó un patrón pero no es un QR válido. Intenta con otra imagen más clara.');
                          } else {
                            console.log(' No se detectó ningún patrón QR en la imagen');
                            setMensaje('No se detectó ningún código QR en la imagen. Asegúrate de que el QR esté completo, bien iluminado y enfocado.');
                          }
                          
                          // Resetear el input
                          e.target.value = '';
                        } catch (err) {
                          console.error('Error al procesar imagen:', err);
                          setMensaje('Error al procesar la imagen: ' + (err?.message || 'Error desconocido'));
                          URL.revokeObjectURL(imageUrl);
                          e.target.value = '';
                        }
                      };
                      
                      img.onerror = () => {
                        setMensaje('Error al cargar la imagen. Intenta con otra foto.');
                        URL.revokeObjectURL(imageUrl);
                        e.target.value = '';
                      };
                      
                      img.src = imageUrl;
                    }}
                  />
                </div>
                <button
                  className="action-button"
                  style={{ marginTop: 8, background: '#e53e3e', color: '#fff', fontWeight: 700 }}
                  onClick={async () => {
                    if (html5QrCodeRef.current) {
                      try {
                        await html5QrCodeRef.current.stop();
                      } catch (e) {}
                    }
                    setScanning(false);
                  }}
                >
                  Cancelar
                </button>
              </div>
            </div>
          )}
          {mensaje && (
            <div className="mensaje-container" style={{
              marginTop: 15, 
              color: mensaje.includes('correctamente') ? '#38a169' : '#e53e3e', 
              fontWeight: 600, 
              fontSize: '1rem',
              padding: '10px',
              borderRadius: '4px',
              backgroundColor: mensaje.includes('correctamente') ? '#f0fff4' : '#fff5f5',
              border: `1px solid ${mensaje.includes('correctamente') ? '#38a169' : '#e53e3e'}`
            }}>
              {mensaje}
            </div>
          )}
          {advertencia && (
            <div className="advertencia-container" style={{
              marginTop: 12, 
              color: '#d97706', 
              fontWeight: 700, 
              fontSize: '1rem',
              padding: '16px 14px',
              borderRadius: '6px',
              backgroundColor: '#fef3c7',
              border: '2px solid #d97706',
              animation: 'pulse 1s ease-in-out infinite',
              boxShadow: '0 4px 12px rgba(217, 119, 6, 0.2)'
            }}>
              {advertencia}
            </div>
          )}
        </>
      )}
      {activeTab === 'horario' && (
        <div className="horario-container">
          <div className="form-row">
            <div className="form-field">
              <label>Mes:</label>
              <select value={mes} onChange={e => setMes(e.target.value)}>
                {[...Array(12)].map((_, i) => (
                  <option key={i+1} value={i+1}>{dayjs().month(i).format('MMMM')}</option>
                ))}
              </select>
            </div>
            <div className="form-field">
              <label>Año:</label>
              <input 
                type="number" 
                value={anio} 
                min="2000" 
                max="2100" 
                onChange={e => setAnio(e.target.value)}
              />
            </div>
          </div>
          {horarioBloqueado ? (
            <div className="horario-blocked-inline">
              {horarioBloqueadoMsg || HORARIO_BLOQUEADO_FALLBACK}
            </div>
          ) : (
            <div style={{marginTop: 15, textAlign: 'right'}}>
              <button type="button" onClick={descargarCSV} className="action-button">Descargar Horario</button>
            </div>
          )}
        </div>
      )}

      {/* ========== PESTAÑA PARTES DE TRABAJO ========== */}
      {activeTab === 'partes' && (
        <div className="partes-container">
          <h3 style={{textAlign:'center', marginBottom:16, color:'#059669', fontSize:'1.3rem'}}>📋 Nuevo Parte de Trabajo</h3>

          {/* FECHA (siempre hoy) */}
          <div className="parte-seccion">
            <label className="parte-label">📅 Fecha</label>
            <input type="date" value={new Date().toISOString().split('T')[0]} readOnly
              className="parte-input" style={{background:'#f3f4f6', cursor:'not-allowed'}} />
          </div>

          {/* TURNO */}
          <div className="parte-seccion">
            <label className="parte-label">⏰ Turno</label>
            <div className="parte-radio-group">
              <button type="button"
                className={`parte-radio-btn ${parteTurno === 'M' ? 'selected' : ''}`}
                onClick={() => setParteTurno('M')}>☀️ Mañana</button>
              <button type="button"
                className={`parte-radio-btn ${parteTurno === 'T' ? 'selected' : ''}`}
                onClick={() => setParteTurno('T')}>🌙 Tarde</button>
            </div>
          </div>

          {/* CATEGORÍA */}
          <div className="parte-seccion">
            <label className="parte-label">📦 Categoría</label>
            <div className="parte-categoria-grid">
              {[{key:'frio', icon:'❄️', label:'Frío'}, {key:'cpus', icon:'💻', label:"CPU's"}, {key:'ofimatica', icon:'🖨️', label:'Ofimática'}, {key:'servicio', icon:'🤝', label:'Servicio Cliente'}].map(cat => (
                <button key={cat.key} type="button"
                  className={`parte-cat-btn ${parteCategoria === cat.key ? 'selected' : ''}`}
                  onClick={() => { setParteCategoria(cat.key); setParteItems({}); setParteServicioHoras({}); }}>
                  <span style={{fontSize:'1.8rem'}}>{cat.icon}</span>
                  <span>{cat.label}</span>
                </button>
              ))}
            </div>
          </div>

          {/* OPERARIOS */}
          <div className="parte-seccion">
            <label className="parte-label">👷 Operarios</label>
            {parteCargandoOps ? (
              <div style={{textAlign:'center', padding:10, color:'#666'}}>Cargando operarios...</div>
            ) : (
              <div className="parte-operarios-list">
                {parteOperarios.map(op => (
                  <button key={op.dni} type="button"
                    className={`parte-operario-btn ${parteOperariosSeleccionados.includes(op.nombre) ? 'selected' : ''}`}
                    onClick={() => {
                      setParteOperariosSeleccionados(prev =>
                        prev.includes(op.nombre) ? prev.filter(n => n !== op.nombre) : [...prev, op.nombre]
                      );
                    }}>
                    {parteOperariosSeleccionados.includes(op.nombre) ? '✅' : '⬜'} {op.nombre}
                  </button>
                ))}
                {parteOperarios.length === 0 && <div style={{color:'#999', padding:10}}>No hay operarios activos en {DEPARTAMENTO_PARTES}</div>}
              </div>
            )}
          </div>

          {/* TIPOS Y CANTIDADES (según categoría) */}
          {parteCategoria && parteCategoria !== 'servicio' && (
            <div className="parte-seccion">
              <label className="parte-label">⚖️ Cantidades (kg)</label>
              <div className="parte-tipos-list">
                {obtenerTiposCategoria(parteCategoria).map(tipo => (
                  <div key={tipo} className="parte-tipo-row">
                    <div className="parte-tipo-nombre">{tipo}</div>
                    <div className="parte-tipo-cantidades">
                      {(parteItems[tipo] || ['']).map((cant, idx) => (
                        <div key={idx} className="parte-cant-row">
                          <input type="number" inputMode="decimal" placeholder="kg"
                            className="parte-kg-input"
                            value={cant}
                            onChange={e => {
                              const val = e.target.value;
                              setParteItems(prev => {
                                const arr = [...(prev[tipo] || [''])];
                                arr[idx] = val;
                                return {...prev, [tipo]: arr};
                              });
                            }} />
                          {idx === (parteItems[tipo] || ['']).length - 1 && (
                            <button type="button" className="parte-add-cant-btn"
                              onClick={() => setParteItems(prev => ({...prev, [tipo]: [...(prev[tipo] || ['']), '']}))}
                              title="Añadir cantidad">+</button>
                          )}
                          {(parteItems[tipo] || ['']).length > 1 && (
                            <button type="button" className="parte-remove-cant-btn"
                              onClick={() => setParteItems(prev => {
                                const arr = [...(prev[tipo] || [''])];
                                arr.splice(idx, 1);
                                return {...prev, [tipo]: arr};
                              })}
                              title="Quitar cantidad">✕</button>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* SERVICIO AL CLIENTE: observación y horas por empleado */}
          {parteCategoria === 'servicio' && (
            <div className="parte-seccion">
              <label className="parte-label">🕐 Empleados - Observación y Horas</label>
              <div className="parte-tipos-list">
                {parteOperariosSeleccionados.length === 0 && (
                  <div style={{color:'#999', padding:10}}>Selecciona operarios primero</div>
                )}
                {parteOperariosSeleccionados.map(nombre => (
                  <div key={nombre} className="parte-tipo-row" style={{display:'grid', gap:8}}>
                    <div style={{fontWeight:'bold', fontSize:'0.95rem'}}>{nombre}</div>
                    <div style={{marginLeft:0}}>
                      <input type="text" placeholder="Observación"
                        style={{width:'100%', padding:'8px', border:'1px solid #ccc', borderRadius:'4px', fontSize:'0.95rem', marginBottom:6}}
                        value={parteServicioHoras[nombre]?.observacion || ''}
                        onChange={e => setParteServicioHoras(prev => ({...prev, [nombre]: {...(prev[nombre] || {}), observacion: e.target.value}}))} />
                    </div>
                    <div style={{display:'flex', gap:8, alignItems:'center'}}>
                      <input type="number" inputMode="decimal" placeholder="horas"
                        className="parte-kg-input" style={{maxWidth:120, flex:1}}
                        value={parteServicioHoras[nombre]?.horas || ''}
                        onChange={e => setParteServicioHoras(prev => ({...prev, [nombre]: {...(prev[nombre] || {}), horas: e.target.value}}))} />
                      <span style={{color:'#666', fontSize:'0.9rem', whiteSpace:'nowrap'}}>horas</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* DESCRIPCIÓN (solo para normal) o RESPONSABLE (solo para servicio) */}
          {parteCategoria !== 'servicio' && (
            <div className="parte-seccion">
              <label className="parte-label">📝 Descripción (opcional)</label>
              <textarea className="parte-textarea" rows="3" placeholder="Escribe una observación si lo necesitas..."
                value={parteDescripcion} onChange={e => setParteDescripcion(e.target.value)} />
            </div>
          )}
          
          {parteCategoria === 'servicio' && (
            <div className="parte-seccion">
              <label className="parte-label">👤 Responsable</label>
              <input type="text" className="parte-input" placeholder="Nombre del responsable"
                value={parteDescripcion} onChange={e => setParteDescripcion(e.target.value)} />
            </div>
          )}

          {/* MENSAJE DE ESTADO */}
          {parteMensaje && (
            <div style={{
              padding: '12px 16px', borderRadius: 8, marginBottom: 12, fontWeight: 600, textAlign: 'center',
              background: parteMensaje.includes('✅') ? '#d1fae5' : '#fee2e2',
              color: parteMensaje.includes('✅') ? '#065f46' : '#991b1b',
              border: `2px solid ${parteMensaje.includes('✅') ? '#059669' : '#dc2626'}`
            }}>{parteMensaje}</div>
          )}

          {/* BOTONES */}
          <div className="parte-botones">
            <button type="button" className="parte-btn-principal"
              disabled={parteGenerando}
              onClick={generarPartePDF}>
              {parteGenerando ? '⏳ Generando...' : '📥 Generar y Descargar PDF'}
            </button>
            <button type="button" className="parte-btn-secundario"
              onClick={limpiarFormularioParte}>🗑️ Limpiar</button>
          </div>
        </div>
      )}

    </div>
    </React.Fragment>
  );
}
